import { Controller } from 'stimulus';
import _ from 'lodash';

export default class extends Controller {

  initialize() {
    this.state = {
      loaded: false,
      loading: false,
      tolerance: 128,
      initialized: false,
      scrollTarget: false,
      cssUrl: '//assets.juicer.io/embed.css',
      scriptUrl: '//assets.juicer.io/embed-no-jquery.js',
      try: 5,
      tryTimeout: 500
    };
  }

  connect() {
    console.log('JuicerFeed : init');
    this.checkLoaded();
    this.setScrollTarget();
    this.checkScrollPosition();
    this.setupEvents();
  }

  disconnect() {
    this.removeEvents();
    this.removeJuicer();
    this.removeScrollEvents();
  }

  setupEvents() {
    this.boundCheckScrollPosition = _.throttle(this.checkScrollPosition.bind(this), this.state.tolerance);
    this.boundRefresh = this.refresh.bind(this);
    this.boundSetScrollTarget = this.setScrollTarget.bind(this);
    this.boundSlickInit = this.slickInit.bind(this);

    $(document).one('turbolinks:before-cache', this.disconnect.bind(this));
    $(window).on('resizeEnd.juicer-feed', this.boundRefresh);
    $(window).on('resizeEnd.juicer-feed', this.boundSetScrollTarget);
    $(window).on('scroll.juicer-feed-scroll', this.boundCheckScrollPosition);
    $(this.element).on('init', this.boundSlickInit);
  }

  removeEvents() {
    $(window).off('.juicer-feed');
  }

  removeScrollEvents() {
    $(window).off('.juicer-feed-scroll');
  }

  checkLoaded() {
    if (window.Juicer) {
      this.state.loaded = true;
    }
  }

  checkScrollPosition() {
    if (!this.state.loading) {
      const currentPosition = $(window).scrollTop();
      if (currentPosition >= this.state.scrollTarget) {
        if (this.state.loaded && !this.state.initialized) {
          this.initializeJuicer();
        } else {
          this.loadJuicer();
        }
      }
    }
  }

  setScrollTarget() {
    const elementOffset = $(this.element).offset().top;
    const viewportHeight = $(window).outerHeight();
    this.state.scrollTarget = Math.round(elementOffset - viewportHeight);
  }

  loadJuicer() {
    if (!this.state.loading && !this.state.loaded) {
      this.state.loading = true;
      this.removeScrollEvents();

      $('<link/>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: this.state.cssUrl
      }).appendTo('head');

      $.getScript(this.state.scriptUrl, () => {
        this.state.loaded = true;
        this.state.loading = false;
        this.initializeJuicer();
      });
    }
  }

  initializeJuicer() {
    if (this.state.loaded && !this.state.initialized) {
      window.Juicer.initialize();
      this.state.initialized = true;
      this.setFilter();
      // Delay to ensure Juicer finishes rendering
      setTimeout(() => {
        this.cleanupAndReinitialize();
      }, 500);
    }
  }

  cleanupAndReinitialize() {
    console.log('Starting cleanup and reinitialization');

    // Wait for images to load and Slick to fully render before measuring height
    this.waitForImagesAndSlick().then(() => {
      // Get the parent and lock its height
      const $parent = $(this.element).closest('.component--social-slider');
      const parentHeight = $parent.outerHeight();

      // Aggressively lock the parent height to prevent any layout shift
      $parent[0].style.setProperty('height', parentHeight + 'px', 'important');
      $parent[0].style.setProperty('overflow', 'hidden', 'important');

      // Store current position info
      const elementRect = this.element.getBoundingClientRect();
      const currentPosition = {
        width: $(this.element).outerWidth(),
        height: $(this.element).outerHeight()
      };

      // Take element out of document flow during cleanup
      this.element.style.setProperty('position', 'absolute', 'important');
      this.element.style.setProperty('visibility', 'hidden', 'important');
      this.element.style.setProperty('transition', 'none', 'important');

      // Get the current Slick settings before destroying
      const slickInstance = $(this.element).slick('getSlick');
      const currentSettings = slickInstance.options;

      // Destroy the existing Slick instance first
      $(this.element).slick('unslick');

      // Now clean up the DOM
      this.removeBrokenImages().then(() => {
        this.removeWordsItems();
        this.ensureMultipleOfFour();
        console.log('Reinitializing slick after cleanup');

        // Reinitialize Slick with the preserved settings
        setTimeout(() => {
          $(this.element).slick(currentSettings);

          // Restore position in document flow
          this.element.style.removeProperty('position');

          // Remove parent height lock
          $parent[0].style.removeProperty('height');
          $parent[0].style.removeProperty('overflow');

          // Switch to opacity for the fade-in effect
          this.element.style.removeProperty('visibility');
          this.element.style.setProperty('opacity', '0', 'important');
          this.element.style.removeProperty('transition');
          this.element.classList.add('juicer-feed--fade-in');

          // Fade in via CSS class
          setTimeout(() => {
            this.element.style.removeProperty('opacity');
          }, 50);
        }, 100);
      });
    });
  }

  waitForImagesAndSlick() {
    return new Promise((resolve) => {
      const images = this.element.querySelectorAll('img');
      let loadedImages = 0;
      const totalImages = images.length;

      if (totalImages === 0) {
        // No images, wait a bit for Slick to render
        setTimeout(resolve, 200);
        return;
      }

      const checkComplete = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          // All images loaded, wait a bit more for Slick layout
          setTimeout(resolve, 200);
        }
      };

      images.forEach((img) => {
        if (img.complete) {
          checkComplete();
        } else {
          img.addEventListener('load', checkComplete);
          img.addEventListener('error', checkComplete); // Count errors as complete too
        }
      });
    });
  }

  refresh() {
    if (this.state.initialized) {
      console.log('Refreshing slick slider', this.element);
      $(this.element).slick('resize');
      setTimeout(() => {
        $(this.element).slick('resize');
      }, this.state.tryTimeout * 1.5);
    }
  }

  slickInit() {
    setTimeout(() => {
      this.refresh();
    }, this.state.tryTimeout);
  }

  removeJuicer() {
    if (window.Juicer && window.Juicer.Active && window.Juicer.Active.length) {
      window.Juicer.remove();
    }
  }

  setFilter() {
    const filter = this.element.dataset.filter;
    if (filter && filter.length > 0) {
      $(this.element).slick('slickFilter', "." + filter);
    }
  }

  removeWordsItems() {
    const wordsItems = this.element.querySelectorAll('li.feed-item.words');
    wordsItems.forEach((item) => {
      console.log('Removing words item:', item);
      item.remove();
    });
  }

  ensureMultipleOfFour() {
    const items = this.element.querySelectorAll('li.feed-item');
    const totalItems = items.length;
    const remainder = totalItems % 4;

    if (remainder !== 0) {
      // Remove the last N items to make it a multiple of 4
      const itemsToRemove = remainder;
      console.log(`Removing ${itemsToRemove} items to make total a multiple of 4`);

      for (let i = totalItems - 1; i >= totalItems - itemsToRemove; i--) {
        items[i].remove();
      }
    }
  }

  removeBrokenImages() {
    return new Promise((resolve) => {
      const items = this.element.querySelectorAll('li.feed-item');
      let pendingImages = 0;
      let checkedImages = 0;

      // Count how many images need to be checked
      items.forEach((item) => {
        const img = item.querySelector('img');
        if (img && !img.complete) {
          pendingImages++;
        }
      });

      const checkComplete = () => {
        checkedImages++;
        if (checkedImages === items.length || (pendingImages === 0 && checkedImages > 0)) {
          resolve();
          console.log('Finished checking images.');
        }
      };

      items.forEach((item) => {
        const img = item.querySelector('img');

        if (img) {
          const checkAndRemove = () => {
            if (img.complete) {
              // Image finished loading (either success or failure)
              if (img.naturalHeight === 0) {
                console.log('Removing broken image item:', item);
                // Image failed to load
                item.remove();
              }
            }
            checkComplete();
          };

          if (img.complete) {
            // Image is already cached/loaded
            checkAndRemove();
          } else {
            // Image is still loading
            img.addEventListener('load', checkAndRemove);
            img.addEventListener('error', () => {
              console.log('Removing broken image item for error:', item);
              item.remove();
              checkComplete();
            });
          }
        } else {
          checkComplete();
        }
      });

      // If no pending images, resolve immediately
      if (pendingImages === 0) {
        resolve();
      }
    });
  }
}
